const AccountSettings = () => import(/* webpackChunkName: "employee-account-settings" */ "@/views/AccountSettings.vue");
import { createRouter, createWebHistory } from "vue-router";
import store from "@/store";
import { isPublicAuthPath } from "@/utils/publicAuthRoutes";
import axios from "axios";
const Dashboard = () => import(/* webpackChunkName: "employee-dashboard" */ "@/views/Dashboard.vue");
const TimeSheet = () => import(/* webpackChunkName: "employee-time-sheet" */ "@/views/TimeSheet.vue");
const InvoiceSheets = () => import(/* webpackChunkName: "employee-invoice-sheets" */ "@/views/InvoiceSheets.vue");
const Message = () => import(/* webpackChunkName: "employee-message" */ "@/views/Message.vue");
const change_password = () => import(/* webpackChunkName: "employee-change-password" */ "@/views/change_password.vue");
const VirtualReality = () => import(/* webpackChunkName: "employee-virtual-reality" */ "@/views/VirtualReality.vue");
const Profile = () => import(/* webpackChunkName: "employee-profile" */ "@/views/Profile.vue");
const Rtl = () => import(/* webpackChunkName: "employee-rtl" */ "@/views/Rtl.vue");
const SignIn = () => import(/* webpackChunkName: "employee-sign-in" */ "@/views/SignIn.vue");
const SwitchClient = () => import(/* webpackChunkName: "employee-switch-client" */ "@/views/switch_client.vue");
const forgot_password = () => import(/* webpackChunkName: "employee-forgot-password" */ "@/views/forgot_password.vue");
const ResetPassword = () => import(/* webpackChunkName: "employee-reset-password" */ "@/views/ResetPassword.vue");
const SignUp = () => import(/* webpackChunkName: "employee-sign-up" */ "@/views/SignUp.vue");
const Enrollment = () => import(/* webpackChunkName: "employee-enrollment" */ "@/views/Enrollment.vue");
const Payroll = () => import(/* webpackChunkName: "employee-payroll" */ "@/views/Payroll.vue");

const routes = [
  { path: "/account-settings", name: "Settings", component: AccountSettings },
  { path: "/invoice-sheets", name: "Invoice Sheets", component: InvoiceSheets },
  {
    path: "/",
    name: "/",
    redirect: "/dashboard",
  },
  {
    path: "/payroll",
    name: "Payroll",
    component: Payroll,
  },
  {
    path: "/dashboard",
    name: "Dashboard",
    component: Dashboard,
  },
  {
    path: "/enrollment",
    name: "Enrollment",
    component: Enrollment,
  },
  {
    path: "/TimeSheet",
    name: "TimeSheet",
    component: TimeSheet,
  },
  {
    path: "/Message",
    name: "Message",
    component: Message,
  },
  {
    path: "/virtual-reality",
    name: "Virtual Reality",
    component: VirtualReality,
  },
  {
    path: "/profile",
    name: "Profile",
    component: Profile,
  },
  {
    path: "/rtl-page",
    name: "Rtl",
    component: Rtl,
  },
  {
    path: "/sign-in",
    name: "Sign In",
    component: SignIn,
  },
  {
    path: "/sign-up",
    name: "Sign Up",
    component: SignUp,
    // Invite-only: never show signup without a valid invitation token in the URL
    beforeEnter: (to, from, next) => {
      const t = to.query.token;
      if (!t || !String(t).trim()) {
        next({ path: "/sign-in", replace: true });
      } else {
        next();
      }
    },
  },
  {
    path: "/forgot_password",
    name: "forgot Password",
    component: forgot_password,
  },
  {
    path: "/reset-password",
    name: "Reset Password",
    component: ResetPassword,
  },
  {
    path: "/change_password",
    name: "Change Password",
    component: change_password,
  },
  {
    path: "/swith_client",
    name: "Swith Client",
    component: SwitchClient,
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  linkActiveClass: "active",
});
router.beforeEach(async (to, from, next) => {
  const token = localStorage.getItem("token");
  const tokenExpiration = localStorage.getItem("tokenExpiration");

  if (isPublicAuthPath(to.path)) {
    store.commit("setAuthPageChrome");
    store.commit("setHideConfiguratorButton", true);
    next();
    return;
  }

  const clearSession = () => {
    for (const key of ["token", "tokenExpiration", "selectedClientId", "clientName", "clientLastName"]) {
      localStorage.removeItem(key);
    }
  };

  // The server can invalidate a token before the browser expiration time.
  if (token && tokenExpiration && new Date().getTime() < tokenExpiration) {
    try {
      const response = await axios.get(
        `${process.env.VUE_APP_BACKEND_DOMAIN}/api/fetch-employee-data`,
        { headers: { Authorization: `Bearer ${token}` }, timeout: 10000 }
      );
      if (localStorage.getItem("token") !== token) return next(false);
      if (response.data.success !== true) {
        clearSession();
        store.commit("setAuthPageChrome");
        store.commit("setHideConfiguratorButton", true);
        return next({ path: "/sign-in", query: { reason: "session-expired" }, replace: true });
      }
    } catch (error) {
      if (localStorage.getItem("token") !== token) return next(false);
      const status = error.response?.status;
      const rejected = status === 401 || status === 403;
      if (rejected) clearSession();
      store.commit("setAuthPageChrome");
      store.commit("setHideConfiguratorButton", true);
      return next({
        path: "/sign-in",
        query: { reason: status === 403 ? "account-inactive" : rejected ? "session-expired" : "verification-unavailable" },
        replace: true,
      });
    }
    const new_expirationTime = new Date().getTime() + 24 * 60 * 60 * 1000;
    localStorage.setItem("tokenExpiration", new_expirationTime);
    store.commit("setDashboardShell", true);
    store.commit("setHideConfiguratorButton", false);
    next();
  } else {
    clearSession();
    store.commit("setAuthPageChrome");
    store.commit("setHideConfiguratorButton", true);
    next({ path: "/sign-in", query: token ? { reason: "session-expired" } : {}, replace: true });
  }
});


export default router;
